export class CompanyInternshipSeasonDataModel implements ICompanyInternshipSeasonDataModel {
  seasonIndex?: number | undefined;
  count?: number | undefined;
  studentIds?: string[] | undefined;

  constructor(data?: ICompanyInternshipSeasonDataModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.seasonIndex = Data["seasonIndex"];
      this.count = Data["count"];
      if (Array.isArray(Data["studentIds"])) {
        this.studentIds = [] as any;
        for (let item of Data["studentIds"])
          this.studentIds!.push(item);
      }
    }
  }

  static fromJS(data: any): CompanyInternshipSeasonDataModel {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyInternshipSeasonDataModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["seasonIndex"] = this.seasonIndex;
    data["count"] = this.count;
    if (Array.isArray(this.studentIds)) {
      data["studentIds"] = [];
      for (let item of this.studentIds)
        data["studentIds"].push(item);
    }
    return data;
  }
}

export interface ICompanyInternshipSeasonDataModel {
  seasonIndex?: number | undefined;
  count?: number | undefined;
  studentIds?: string[] | undefined;
}